var $ = require('../internals/export');

var assign = require('../internals/object-assign'); // `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign


$({
  target: 'Object',
  stat: true,
  forced: Object.assign !== assign
}, {
  assign: assign
});